if (!customElements.get('promo-code-input')) {
  customElements.define(
    'promo-code-input',
    class PromoCodeInput extends HTMLElement {
      constructor() {
        super();
        let submitBtn = this.querySelector('#apply-coupon');
        let codeTags = this.querySelectorAll('.remove-discount');
        const input = this.querySelector('#coupon-code');

        if(submitBtn){
          submitBtn.addEventListener('click', this.applyDiscount.bind(this));
        }
        codeTags.forEach(codeTag => codeTag.addEventListener("click", this.removeDiscounts.bind(this)));
        input.addEventListener('change', () => {
          input.classList.remove('error');
          this.querySelector('.custom-discount-form p.error').style.display = "none";
        }); 
      }

      connectedCallback() {
        const openInput = this.querySelector('.plus-icon.btn-input__open');
        const closeInput = this.querySelector('.minus-icon.btn-input__open');
        const removeIcon = this.querySelector('.remove-discount-icon');
        const textAddPromo = this.querySelector('.add-promo-title')

        removeIcon.addEventListener('click', this.removeDiscounts.bind(this));
        openInput.addEventListener('click', () => this.classList.toggle('open'));
        closeInput.addEventListener('click', () => this.classList.toggle('open'));
        textAddPromo.addEventListener('click', () => this.classList.toggle('open'));
      }
    
      disconnectedCallback() {
        this.events.unregisterAll();
      }

      close() {
        this.classList.remove('open');
        this.querySelector('#apply-coupon').classList.remove('processing');
        this.querySelector('#apply-coupon').removeAttribute('disabled');
      }
    
      _updateCart() {
        fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
        .then(res => {
          return res.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const oldEl = document.querySelector('.drawer__footer-bottom--information');
          if(document.querySelector('.drawer__footer-bottom--information') && doc.querySelector('.drawer__footer-bottom--information').innerHTML) {
            oldEl.innerHTML = doc.querySelector('.drawer__footer-bottom--information').innerHTML;
          }
        })
      }
    
      applyDiscount(e) {
          e.preventDefault();
          let discountCode = this.querySelector('#coupon-code').value;
          if(discountCode !== '') {
            this.querySelector('#apply-coupon').classList.add('processing');
            this.querySelector('#apply-coupon').setAttribute('disabled', 'disabled');
            this.querySelector('.custom-discount-form p.error').style.display = "none"
            const targetUrl = '/discount/'+ discountCode;
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                discount: discountCode
              }),
            }).finally(() => {
              fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                  if(cart.cart_level_discount_applications.find(item => item.title === discountCode.toUpperCase())) {
                    fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
                    .then(res => {
                      return res.text();
                    })
                    .then(html => {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(html, 'text/html');
                      const parentElement = document.querySelector('.discount__action--title');
                      const oldEl = document.querySelector('.code');
                      if(oldEl && doc.querySelector('.code').innerHTML) {
                        oldEl.replaceWith(doc.querySelector('.code'));
                      } else {
                        parentElement.appendChild(doc.querySelector('.code'))
                      }
                      this.querySelector('#coupon-code').value = '';
                      this.classList.add('applied-discount');
                      this.close();
                      this.querySelector('.add-promo-title').classList.replace('show', 'hide');
                      this.querySelector('.applied-promo-title').classList.replace('hide', 'show');
                    });
                    this._updateCart();
                  } else {
                    const errorElement = this.querySelector('.custom-discount-form p.error');
                    const inputElement = this.querySelector('#coupon-code');
                    errorElement.style.display = 'block';
                    inputElement.classList.add('error');
                    this.querySelector('#apply-coupon').classList.remove('processing');
                    this.querySelector('#apply-coupon').removeAttribute('disabled');
                  }
              })
              
            })
          }
      }

      removeDiscounts(e) {
        e.preventDefault();
        this.classList.remove('applied-discount');
        this.querySelector('.add-promo-title').classList.replace('hide', 'show');
        this.querySelector('.applied-promo-title').classList.replace('show', 'hide');
        this.querySelector('.code').classList.replace('show', 'hide');
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: ""
          }),
        }).finally(() => {
          this._updateCart();
        })
      }
    }
  );
}